import Button from "@/shared/form/button";
import { usePalette } from "@/shared/theme";
import { PhoneOutlined } from "@ant-design/icons";

export function PersonPhone({ phone }: { phone: string | null | undefined }) {
  const palette = usePalette();

  if (!phone) {
    return null;
  }

  return (
    <Button
      href={`tel:${phone}`}
      type="default"
      size="small"
      icon={<PhoneOutlined />}
      className="!rounded-lg !text-xs"
      style={{
        color: palette.success[7],
        backgroundColor: palette.success[0],
        borderColor: palette.success[1],
      }}
    >
      {phone}
    </Button>
  );
}
